<div class="grid h-screen m-0 flex justify-content-center small-screen-padding">
  <div
    class="desktop-view sm:col-12 md:col-12 lg:col-12 xl:col-6 container-izquierdo"
  >
    <img
      src="../../../../../../assets/img/login/logo-comision 1.svg"
      alt=""
      class="logo my-5"
    />
    <div class="desktop-content">
      <span class="font-bold text-3xl">SICOL</span>
      <p class="max-w-30rem text-center">
        Un Sistema de la Comisión Paritaria Permanente de Relaciones Laborales
      </p>
      <a href="https://www.encodelabs.com.ar/home" target="_blank">
        <img
          class="img-logo md:mt-6"
          src="../../../../../../assets/img/login/new-logo-encode-white.png"
          alt=""
        />
      </a>
      <p class="version text-center">v.3.0</p>
    </div>
  </div>

  <div class="mobile-view">
    <img
      class="logo my-5"
      src="../../../../../../assets/img/login/logo-mobile.svg"
      alt=""
    />
  </div>

  <div class="sm:col-12 md:col-12 lg:col-12 xl:col-6 bg-surface-100 flex">
    <div
      class="w-full h-full flex align-items-center justify-content-center small-screen-padding"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
